export const Routes = {
  Login: 'login',
  ForgotPassword: 'forgot-password',
  ResetPassword: 'reset-password',

  NotFound: 'not-found',
  Forbidden: 'forbidden',

  Dashboard: 'dashboard',
  KnowledgeHub: 'knowledge-hub',

  Timesheet: 'timesheet',
  UserTimesheets: 'user-timesheets',
  UserTimesheet: 'user-timesheet',

  StaffIndex: 'staff',
  StaffMember: 'staff.member',
  StaffMemberOverview: 'staff.member.overview',
  StaffMemberOperationalBases: 'staff.member.operational-bases',
  StaffMemberRole: 'staff.member.role',
  StaffExperienceQualifications: 'staff.experienceQualifications',
  StaffMemberPermissions: 'staff.memberPermissions',
  StaffMemberAbilities: 'staff.memberAbilities',
  StaffMemberEmploymentLogs: 'staff.memberEmploymentLogs',
  StaffMemberEmploymentLogsCreate: 'staff.memberEmploymentLogs.create',
  StaffMemberEmploymentLogsEdit: 'staff.memberEmploymentLogs.edit',

  Schedule: 'schedule',
  Alerts: 'alerts',
  DailyAgenda: 'daily-agenda',
  DailyAgendaClassic: 'daily-agenda-classic',
  DailyAgendaV2: 'daily-agenda-v2',
  DailySummary: 'daily-summary',
  EODReport: 'eod-report',

  CustomEventIndex: 'custom-events',
  CustomEventManagement: 'custom-event-management',
  CustomEventCreate: 'custom-event-management.create-custom-event',
  CustomEventUpdate: 'custom-event-management.update-custom-event',

  ViewAssignmentFeedbackLogs: 'assignment-feedback-logs',

  Department: 'department',
  Departments: 'departments',
  DepartmentCreateRole: 'department.create-role',
  DepartmentUpdateRole: 'department.update-role',
  DepartmentCreateShiftCategory: 'department.create-shift-category',
  DepartmentUpdateShiftCategory: 'department.update-shift-category',
  DepartmentCreateShiftCategoryAttribute: 'department.create-shift-category-attribute',
  DepartmentUpdateShiftCategoryAttribute: 'department.update-shift-category-attribute',

  Deviations: 'deviations',
  CreateDeviation: 'create-deviation',
  ViewDeviation: 'view-deviation',

  Hoeys: 'hoeys',
  CreateHoey: 'create-hoey',
  ViewHoey: 'view-hoey',

  EventNotificationSettings: 'event-notification-settings',

  HolidayRequests: 'holiday-requests',
  HolidayRequestsEdit: 'holiday-requests.edit',

  Incidents: 'incidents',
  IncidentCreate: 'incident.create',
  IncidentReportCreate: 'incident-report.create',
  IncidentEdit: 'incident.edit',
  IncidentSettings: 'incident.settings',

  IncidentMetrics: 'incident-metrics',
  AssessmentsAndTrainingMetrics: 'assessments-and-training-metrics',
  OnSiteSalesMetrics: 'on-site-sales-metrics',
  DailyClientTotals: 'daily-client-totals',
  AnnualClientTotals: 'annual-client-totals',
  SeatUtilisationRates: 'seat-utilisation-rates',

  Experiences: 'experiences',
  ExperienceCreate: 'experience.create',
  ExperienceEdit: 'experience.edit',
  ExperienceEditOverview: 'experience.edit.overview',
  ExperienceEditLocation: 'experience.edit.location',
  ExperienceEditSchedule: 'experience.edit.schedule',
  ExperienceEditRequirements: 'experience.edit.requirements',
  ExperienceEditTransport: 'experience.edit.transport',
  ExperienceEditVisibility: 'experience.edit.visibility',
  ExperienceEditTripScripts: 'experience.edit.trip-scripts',

  Assessments: 'assessments',
  AssessmentCreate: 'assessment.create',
  AssessmentEdit: 'assessment.edit',
  AssessmentStaffList: 'assessment.staff-list',
  AssessmentStaffLogs: 'assessment.staff-logs',
  AssessmentStaffLogsCreate: 'assessment.staff-logs.create',

  Training: 'training',
  TrainingCreate: 'training.create',
  TrainingEdit: 'training.edit',
  TrainingStaffList: 'training.staff-list',
  TrainingStaffLogs: 'training.staff-logs',
  TrainingStaffLogsCreate: 'training.staff-logs.create',

  OperationalBases: 'operational-bases',
  OperationalBaseCreate: 'operational-base.create',
  OperationalBaseEdit: 'operational-base.edit',

  ExperienceLocationCreate: 'experience-location.create',
  ExperienceLocationEdit: 'experience-location.edit',

  Maps: 'maps',

  Vehicles: 'vehicles',
  VehicleManagement: 'vehicle-management',
  VehicleManagementOverview: 'vehicle-management.overview',
  VehicleManagementImageGallery: 'vehicle-management.image-gallery',
  VehicleManagementIssueReports: 'vehicle-management.issue-reports',
  VehicleManagementCleaningLogs: 'vehicle-management.cleaning-logs',
  VehicleManagementAssignments: 'vehicle-management.assignments',
  VehicleManagementAllocations: 'vehicle-management.allocations',
  VehicleManagementDepartmentAvailabilityLogs: 'vehicle-management.department-availability-logs',
  VehicleManagementGarageAssignmentLogs: 'vehicle-management.garage-assignment-logs',
  VehicleManagementComments: 'vehicle-management.comments',
  VehicleManagementMaintenanceTickets: 'vehicle-management.maintenance-tickets',
  VehicleCreate: 'vehicle-create',
  VehicleUpdate: 'vehicle-update',
  VehicleCreateCleaningLog: 'vehicle-management.create-cleaning-log',
  VehicleCreateIssueReport: 'vehicle-management.create-issue-report',
  VehicleCreateDepartmentAvailabilityLog: 'vehicle-management.create-department-availability-log',
  VehicleCreateAllocation: 'vehicle-management.create-allocation',
  VehicleManagementCreateMaintenanceTicket: 'vehicle-management.create-maintenance-log',
  VehicleManagementViewMaintenanceTicket: 'vehicle-management.view-maintenance-log',
  VehicleCreateGarageAssignmentLog: 'vehicle-management.create-garage-assignment-log',

  VehicleMaintenanceProviders: 'vehicle-maintenance-providers',
  VehicleMaintenanceProvidersCreate: 'vehicle-maintenance-providers.create',
  VehicleMaintenanceProvidersEdit: 'vehicle-maintenance-providers.edit',

  VehiclesAssignedToGarage: 'vehicles-assigned-to-garage',

  VehicleMaintenanceTickets: 'vehicle-maintenance-tickets',
  VehicleMaintenanceTicketEdit: 'vehicle-maintenance-ticket.edit',
} as const

export type ValidRoute = typeof Routes[keyof typeof Routes]
